import slugify from "slugify";
import type { BusinessAddressVisibilityType } from "@repo/database";

type ListingSlugInput = {
  pitch: string | null;
  businessType: { name: string } | null;
  businessAddressVisibility: BusinessAddressVisibilityType;
  business: {
    address: {
      streetAddress1: string | null;
      city: string | null;
      state: string | null;
    } | null;
  } | null;
  id: number;
};

export function buildListingSlug(
  listing: ListingSlugInput,
) {
  return buildListingSlugOptimistic({
    pitch: listing.pitch ?? undefined,
    businessTypeName: listing.businessType?.name ?? undefined,
    businessAddressVisibility: listing.businessAddressVisibility,
    streetAddress1: listing.business?.address?.streetAddress1,
    city: listing.business?.address?.city,
    state: listing.business?.address?.state,
    id: listing.id,
  });
}

export function buildListingSlugOptimistic({
  pitch,
  businessTypeName,
  businessAddressVisibility,
  streetAddress1,
  city,
  state,
  id,
}: {
  pitch?: string;
  businessTypeName?: string;
  businessAddressVisibility: BusinessAddressVisibilityType;
  streetAddress1?: string | null;
  city?: string | null;
  state?: string | null;
  id: number;
}) {
  const title = pitch ?? businessTypeName;

  const finalAddress = (
    businessAddressVisibility === "EXACT" && streetAddress1
      ? [streetAddress1, city, state]
      : [city, state]
  )
    .filter((part) => !!part)
    .join(", ");

  if (!title) {
    return null;
  }

  if (finalAddress.length === 0) {
    return slugify(`${title} ${id}`, {
      lower: true,
      strict: true,
    });
  }

  return slugify(`${title} in ${finalAddress} ${id}`, {
    lower: true,
    strict: true,
  });
}
